if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog')
        };

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.addEventListener('click', (evt) => {
          if (evt.target.closest('[data-no-variant-selected]')) {
            evt.preventDefault();

            if (this.querySelector('.product-form__warning-message')) {
              return;
            }

            const errorMessage = document.createElement('span');
            errorMessage.classList.add('product-form__warning-message');
            errorMessage.textContent = window.variantStrings.select_size_to_add;

            evt.target.insertAdjacentElement('afterend', errorMessage);
          }
        }); 
      }

      async removeCartItem(itemKey, itemLine) {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';
        config.method = 'POST';
        config.body = JSON.stringify({
          id: itemKey,
          quantity: 0,
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        });


        // Add A modifiying class to the modified cart item element
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          const cartDrawerItem = cartDrawer.querySelector(`#CartDrawer-Item-${itemLine}`);
          if (cartDrawerItem) {
            cartDrawerItem.classList.add('modifying');
          }
        }

        try {
          const response = await fetch(`${routes.cart_change_url}`, config);
          if (!response.ok) {
            throw new Error('Error removing item from cart');
          }
          return await response.json();
        } catch (error) {
          console.error('Error removing item:', error);
          throw error;
        }
      }

      async fetchCartSections() {
        const params = new URLSearchParams();
        params.append('sections', this.cart.getSectionsToRender().map((section) => section.id).join(','));
        params.append('sections_url', window.location.pathname);

        const response = await fetch(`/cart?${params.toString()}`);
        return await response.json();
      }

      async replaceFormInputsForReplacementItem() {
        // When cart add request fails with 422 - Fails to add all quantity due to availability
        // It doesn't return the added item details in the response
        // So we need to fetch the cart and get the latest addition 
        // And manually replace the form inputs with the latest addition details

        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        const latestAddition = cart.items[0];
        const { key, variant_id, properties } = latestAddition;

        const itemToReplaceKeyEl = this.form.querySelector('[name="item-to-replace-key"]');
        const itemToReplaceElLineEl = this.form.querySelector('[name="item-to-replace-el-line"]');
        const itemToReplaceVariantIdEl = this.form.querySelector('[name="item-to-replace-variant-id"]');
        const itemToReplacePropertiesEl = this.form.querySelector('.item-properties-json');

        if (itemToReplaceKeyEl) itemToReplaceKeyEl.value = key;
        if (itemToReplaceElLineEl) itemToReplaceElLineEl.value = 1;
        if (itemToReplaceVariantIdEl) itemToReplaceVariantIdEl.value = variant_id;
        if (itemToReplacePropertiesEl) itemToReplacePropertiesEl.textContent = JSON.stringify(properties);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.replacementErrorMessage = null;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Check if we're modifying an existing cart item
        const isReplacing = formData.has('item-to-replace-key');
        const itemToReplaceKey = isReplacing ? formData.get('item-to-replace-key') : null;
        const itemToReplaceElLine = isReplacing ? formData.get('item-to-replace-el-line') : null;
        const itemToReplaceVariantId = isReplacing ? formData.get('item-to-replace-variant-id') : null;
        const itemToReplaceProperties = isReplacing ? this.querySelector('.item-properties-json') : null;

        // Prepare cart sections data
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // If we're replacing an item, remove it first and then add the new item
        const processForm = async () => {
          let originalItemDetails = null;

          try {
            // If we're replacing an item, remove it first and store its details
            if (isReplacing) {
              // Store the original item details before removing
              originalItemDetails = {
                key: itemToReplaceKey,
                line: itemToReplaceElLine,
                variantId: itemToReplaceVariantId,
                properties: itemToReplaceProperties ? JSON.parse(itemToReplaceProperties.textContent) : null
              };

              // Remove the item to be replaced
              await this.removeCartItem(itemToReplaceKey, itemToReplaceElLine);
            }

            // Add the new item
            const addItemResponse = await fetch(`${routes.cart_add_url}`, config);
            const addItemResponseJson = await addItemResponse.json();
            const quantityErrorButSuccess = addItemResponseJson.message?.includes('due to availability');

            // If the item failed to add
            if (addItemResponseJson.status) {
              this.replacementErrorMessage = addItemResponseJson.message;

              // Addition Partially Failed, but at least one item was added due to quantity error, return the cart with sections
              if (quantityErrorButSuccess) {
                const cartWithSectionsResponse = await this.fetchCartSections();
                this.replaceFormInputsForReplacementItem();

                return {
                  sections: cartWithSectionsResponse,
                };
              } else {
                // Addition completely failed, try to restore the original item if needed
                if (isReplacing && originalItemDetails) {
                  // Re-add the original item that was removed
                  const restoreConfig = fetchConfig('javascript');
                  restoreConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
                  delete restoreConfig.headers['Content-Type'];

                  const restoreFormData = new FormData();
                  restoreFormData.append('id', originalItemDetails.variantId);
                  restoreFormData.append('quantity', 1);

                  // Add back any properties the original item had
                  if (originalItemDetails.properties) {
                    for (const [key, value] of Object.entries(originalItemDetails.properties)) {
                      restoreFormData.append(key, value);
                    }
                  }

                  if (this.cart) {
                    restoreFormData.append(
                      'sections',
                      this.cart.getSectionsToRender().map((section) => section.id)
                    );
                    restoreFormData.append('sections_url', window.location.pathname);
                  }

                  restoreConfig.body = restoreFormData;

                  // Re-add the original item
                  const restoreResponse = await fetch(`${routes.cart_add_url}`, restoreConfig);
                  const restoreResponseJson = await restoreResponse.json();
                  return restoreResponseJson;
                }

                return addItemResponseJson;
              }
            }

            return addItemResponseJson;
          } catch (error) {
            console.error('Error processing form:', error);
            throw error;
          }
        };

        processForm()
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (this.replacementErrorMessage) {
              this.handleErrorMessage(this.replacementErrorMessage);
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                replaced: isReplacing
              });

              if (isReplacing && !this.replacementErrorMessage) {
                document.dispatchEvent(new CustomEvent('item-modified', {
                  detail: {
                    itemKey: itemToReplaceKey,
                    itemLine: itemToReplaceElLine
                  }
                }));
              }
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
